import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { FilterPipe } from './filter/filter';
import { ProductFilterPipe } from './product-filter/productFilter'
import { HtmlTemplateRenderPipe } from './html-template-render/html-template-render';
@NgModule({
	declarations: [FilterPipe,ProductFilterPipe,
    HtmlTemplateRenderPipe],
	imports: [
		IonicModule,
		CommonModule
	],
	exports: [FilterPipe,ProductFilterPipe,
    HtmlTemplateRenderPipe]
})
export class PipesModule {
	static forRoot() {
		return {
			ngModule: PipesModule,
			providers: [],
		};
	 }
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts